import React, { useState } from 'react';
import PropTypes from 'prop-types';

import trackGTMEvents from 'shared-utils/src/trackGTMEvents';

import Header from '../Header/index';
import Navigation from '../Navigation/index';
import MyCasaMenu from '../MyCasaMenu/index';

const propTypes = {
  hasShadow: PropTypes.bool,
  isTransparent: PropTypes.bool,
  isFixed: PropTypes.bool,
  isHidden: PropTypes.bool,
  isHiding: PropTypes.bool,
  hidePublish: PropTypes.bool,
  user: PropTypes.instanceOf(Object),
  logIn: PropTypes.func,
  logOut: PropTypes.func,
  backButton: PropTypes.instanceOf(Object),
  noLoginModal: PropTypes.bool,
  noMycasamenu: PropTypes.bool,
  portalDomain: PropTypes.string,
  accountDomain: PropTypes.string,
  authBasePrefix: PropTypes.string,
  myCasaDomain: PropTypes.string,
  mobileOs: PropTypes.string,
  fromPortal: PropTypes.bool,
  isHp: PropTypes.bool,
};
const defaultProps = {
  hasShadow: false,
  isTransparent: false,
  isFixed: false,
  isHidden: false,
  isHiding: false,
  hidePublish: false,
  user: null,
  logIn: () => {},
  logOut: () => {},
  backButton: null,
  noLoginModal: false,
  noMycasamenu: false,
  portalDomain: 'https://www.casa.it',
  accountDomain: 'https://www.casa.it',
  authBasePrefix: '/my',
  myCasaDomain: 'https://www.casa.it',
  mobileOs: '',
  fromPortal: false,
  isHp: false,
};

const PortalHeader = ({
  hasShadow,
  isTransparent,
  isFixed,
  isHidden,
  isHiding,
  hidePublish,
  user,
  logIn,
  logOut,
  backButton,
  noLoginModal,
  noMycasamenu,
  portalDomain,
  accountDomain,
  myCasaDomain,
  mobileOs,
  fromPortal,
  isHp,
  authBasePrefix
}) => {
  const [navOpen, setNavOpen] = useState(false);
  const toggleNav = () => {
    if (document.documentElement.clientWidth < 768) {
      if (!navOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
    if (isHp && !navOpen) {
      trackGTMEvents(
        'Interaction',
        'OpenMenuHP',
      );
    }
    setNavOpen(!navOpen);
  }
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => {
    if (!menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    setMenuOpen(!menuOpen);
  };
  const doLogout = () => {
    toggleMenu();
    logOut(`${accountDomain}${authBasePrefix}`);
  }

  return (
    <>
      <Header
        hasShadow={hasShadow}
        isTransparent={isTransparent}
        isFixed={isFixed}
        isHidden={isHidden}
        isHiding={isHiding}
        hidePublish={hidePublish}
        logIn={logIn}
        user={user}
        toggleNav={toggleNav}
        isNavOpen={navOpen}
        toggleMenu={toggleMenu}
        backButton={backButton}
        noLoginModal={noLoginModal}
        noMycasamenu={noMycasamenu}
        portalDomain={portalDomain}
        accountDomain={accountDomain}
        authBasePrefix={authBasePrefix}
        myCasaDomain={myCasaDomain}
        fromPortal={fromPortal}
      />
      <Navigation
        isFixed={isFixed}
        isHidden={isHidden}
        toggleNav={toggleNav}
        isOpen={navOpen}
        isTransparent={isTransparent}
        portalDomain={portalDomain}
        mobileOs={mobileOs}
        fromPortal={fromPortal}
      />
      {
        user && user.isAuthenticated
          && (
            <MyCasaMenu
              toggleMenu={toggleMenu}
              isOpen={menuOpen}
              user={user}
              logOut={doLogout}
              portalDomain={portalDomain}
              accountDomain={accountDomain}
              authBasePrefix={authBasePrefix}
              myCasaDomain={myCasaDomain}
              fromPortal={fromPortal}
            />
          )
      }
    </>
  );
};
PortalHeader.propTypes = propTypes;
PortalHeader.defaultProps = defaultProps;
export default PortalHeader;